<ngx-loading-bar [color]="'#7366ff'" [includeSpinner]="false" [height]="'4px'"></ngx-loading-bar>
<app-loader *ngIf="!refreshingTheView"></app-loader>
<app-tap-to-top></app-tap-to-top>
<router-outlet *ngIf="!refreshingTheView"></router-outlet>
<tour-step-template></tour-step-template>